import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { InputMaterial } from '../input/input';
import PolygonIcon from '../../../assets/icons/polygon.svg';
import * as LocalStorageUtil from '../../../utils/LocalStorageUtil';
import './select.scss';
export var CustomSelect = function (props) {
    var defaultText = props.defaultText, options = props.options, onClick = props.onClick;
    var _a = useState(""), defaultSelectText = _a[0], setDefaultSelectText = _a[1];
    var _b = useState(false), showOptionList = _b[0], setShowOptionList = _b[1];
    var _c = useState([]), optionsList = _c[0], setOptionsList = _c[1];
    var _d = useState(""), keyword = _d[0], setKeyword = _d[1];
    useEffect(function () {
        setDefaultSelectText(defaultText);
    }, []);
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowOptionList(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    useEffect(function () {
        setDefaultSelectText(defaultText);
    }, [defaultText]);
    useEffect(function () {
        var optionList = [];
        if (options) {
            optionList = _.sortBy(options, function (option) { return option.name; });
        }
        setOptionsList(optionList);
    }, [options]);
    var selectRef = useRef(null);
    useOutsideAlerter(selectRef);
    var onSearchKeyword = function (value) {
        var listSearch = _.cloneDeep(options);
        listSearch = _.sortBy(listSearch, function (option) { return option.name; });
        listSearch = listSearch.filter(function (searchKey) {
            var valueKey = searchKey.name.toLowerCase();
            return valueKey.indexOf(value.toLowerCase()) > -1;
        });
        setOptionsList(listSearch);
    };
    var handleListDisplay = function () {
        setShowOptionList(!showOptionList);
    };
    var handleOptionClick = function (event, option) {
        LocalStorageUtil.removeItem(LocalStorageUtil.PUBDESK_INVENTORIES_SELECTED);
        setDefaultSelectText(event.target.getAttribute("data-name"));
        setShowOptionList(false);
        onClick(option);
    };
    return (React.createElement("div", { className: "custom-select-container", ref: selectRef },
        React.createElement("div", { className: (showOptionList ? "selected-text active" : "selected-text")
                + (props.dropdownStyle ? " " + props.dropdownStyle : ''), onClick: handleListDisplay },
            React.createElement("div", { className: "label-select-text" },
                React.createElement("span", { className: "label" + (props.labelStyle ? " " + props.labelStyle : '') }, defaultSelectText)),
            React.createElement("div", null,
                React.createElement("img", { src: props.icDropdown ? props.icDropdown : PolygonIcon }))),
        showOptionList && (React.createElement("div", { className: "custom-select-option", style: { position: "absolute", zIndex: 9999999 } },
            React.createElement("div", { className: "custom-select-search" },
                React.createElement(InputMaterial, { value: keyword, type: "text", text: "", setter: setKeyword, multiline: true, onChange: onSearchKeyword, placeholder: "Search name..." })),
            React.createElement("ul", { className: "select-options" }, optionsList.map(function (option, index) {
                return (React.createElement("li", { className: "custom-select-option", "data-name": option.name, key: option.id, onClick: function (event) { return handleOptionClick(event, option); } }, option.name));
            }))))));
};
export default CustomSelect;
